import { Helmet } from "react-helmet-async";

/**
 * Renders one or more schema.org JSON-LD blocks in the document head.
 *
 * Usage:
 *   <JsonLd data={{ "@context": "https://schema.org", "@type": "Organization", ... }} />
 *   <JsonLd data={[orgSchema, websiteSchema]} />
 */
export default function JsonLd({ data }) {
  const blocks = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
